<template>
  <div class="item" :class="props.isActive && 'item--active'">
    <transition name="item__animation-opacity">
      <IndicatorPoint class="item__indicator" v-if="props.isActive"/>
    </transition>
    <p>{{ props.text }}</p>
    <time>{{ props.time }}</time>
  </div>
</template>

<script setup>
  import { Props } from './props';
  //--------------------------------
  import { IndicatorPoint } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //--------------------------------
  const props = defineProps(Props());
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>